module.exports = __webpack_public_path__ + "img/countries-standard.0ff71b8c.png";